// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__FPVDh","showModal":"Modal_showModal__RkYNh","outer":"Modal_outer__d1zKV","close":"Modal_close__AkiOo"};